import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
} from '@mui/material';
import { i18n } from '@lingui/core';

export const RefreshModal = props => {
  const { open, onClose } = props;
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight + 'px');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="refresh-dialog"
      sx={{
        '& .MuiDialog-container': {
          height: viewportHeight,
        },
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: { xs: '350px', md: '600px' },
        },
        '& .MuiDialogActions-root': {
          p: 0,
        },
        textAlign: 'center',
      }}
    >
      <DialogTitle id="testinput-dialog-title" sx={{ pb: 0 }}>
        {i18n._('Whoops! Your session is expired')}
      </DialogTitle>
      <DialogContent
        sx={{
          '&:first-of-type': {
            paddingTop: 2,
          },
        }}
      >
        <Typography sx={{ pb: 2 }}>{i18n._('Click to open the page again.')}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          backgroundColor: 'background.default',
        }}
      >
        <Button onClick={onClose} fullWidth sx={{ p: 2 }}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
